const MuiAppBar = {
    styleOverrides: {
      root: {
        padding: "1.375rem 0",
      },
    },
  };
  
  export default MuiAppBar;